import { timeAgo } from '../shared/date';

const trackedEmailWithBreachesMapper = {
    toDomain(data) {
        return {
            id: data.id,
            email: data.email,
            totalBreaches: data.totalBreaches,
            resolvedBreaches: data.resolvedBreaches,
            lastCheckedTimeAgo: timeAgo(data.lastCheckedAt),
            breaches: data.breaches.map(breach => ({
                id: breach.id,
                name: breach.name,
                title: breach.title,
                description: breach.description,
                logoPath: breach.logoPath,
                compromisedData: breach.compromisedData,
                isResolved: breach.isResolved
            }))
        }
    }
};

export {
    trackedEmailWithBreachesMapper
};
